import { Globe, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useVisibility } from "@/contexts/VisibilityContext";
import { useAuth } from "@/contexts/AuthContext";

export function PublicModeIndicator() {
  const { isPublicMode, deactivatePublicMode } = useVisibility();
  const { isAdmin } = useAuth();

  // Only show for admins when public mode is active
  if (!isAdmin || !isPublicMode) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-yellow-500 text-yellow-950 py-2 px-4 flex items-center justify-center gap-4 shadow-lg">
      <Globe className="h-4 w-4" />
      <span className="text-sm font-medium">
        PUBLIC MODE ACTIVE — All content is visible to everyone
      </span>
      <Button
        variant="outline"
        size="sm"
        className="h-7 bg-yellow-600 border-yellow-700 text-yellow-50 hover:bg-yellow-700 hover:text-yellow-50"
        onClick={deactivatePublicMode}
      >
        <X className="h-3 w-3 mr-1" />
        Restore Settings
      </Button>
    </div>
  );
}
